import { MessagesGetResultApi, ThreadApi } from 'api-typings/contests/contests';
import { _transformMessageApiToContestMessage } from '../contest-messages';
import { ContestEntryMessage } from './contest-entry-messages.model';

export function transformEntryMessageThread(
  entry: ThreadApi,
  usersList?: MessagesGetResultApi['users'],
): ContestEntryMessage {
  return {
    id: entry.message.id || 0,
    contestId: entry.message.contest_id,
    entryId: entry.message.entry_id ? entry.message.entry_id : 0,
    message: _transformMessageApiToContestMessage(entry.message, usersList),
    replies: entry.replies
      ? entry.replies.map(reply =>
          _transformMessageApiToContestMessage(reply, usersList),
        )
      : undefined,
  };
}
